import FooterSetup from '@/features/design-system/components/common/FooterSetup'
import { DATA_PAGINATION } from '@/types'
import { SensorDetailImport } from '@/types/sensor'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface Props {
  data?: DATA_PAGINATION<SensorDetailImport>
}

const SensorTable: FC<Props> = ({ data }) => {
  return (
    <Stack flexGrow="1" height="100%" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead
            sx={{
              borderBottom: 'none',
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Sensor ID
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  borderRight: '1px solid #d7d7d7',
                }}
              >
                Weather Station Name
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Sensor Identifier
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Update Soil Moisture Sensor Name
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #d7d7d7',
                  }}
                >
                  {row.weatherStationName}
                </TableCell>
                <TableCell>{row.sensorIdentifier || '-'}</TableCell>
                <TableCell>{row.sensorName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack mt="20px">
        <FooterSetup
          title={`${data?.totalCount || 0} rows of data detected`}
          subtitle="Review the data before proceeding"
        />
      </Stack>
    </Stack>
  )
}

export default SensorTable
